<template>
  <span>
    <component
      class="qmkey-chip"
      v-for="elem in items_list"
      :key="elem.component+'_'+elem.name"
      :is="elem.component"
      :item="elem"
      :disable="disable"
      @update="chip_clicked"
      />
  </span>
</template>

    
<script>
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
  import ChipUser from '@/components/explorer/chips/ChipUser';
  import ChipDateRange from '@/components/explorer/chips/ChipDateRange';
  import ChipDateField from '@/components/explorer/chips/ChipDateField';
  import ChipProcess from '@/components/explorer/chips/ChipProcess';
  export default {
    name: 'ListChip',
    
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
    
    components: {
      ChipGeneric,
      ChipList: () => import('@/components/explorer/chips/ChipList'),
      ChipUser,
      ChipDateRange,
      ChipDateField,
      ChipProcess,
      ChipProcesses : () => import('@/components/explorer/chips/ChipProcesses'),
      ChipAdvancedFilter: () => import('@/components/explorer/chips/ChipAdvancedFilter')
    },
    
    computed: {
      items_list() {
        let items = this.item.items || [];
        items.map(item => ({  component: item.component || 'ChipGeneric',
                              readable: item.readable,
                              name: item.name,
                              value: item.value,
                              readableValue: item.readableValue}));
        return items;
      },
    },
  
    methods: {
      chip_clicked(selected_item){
        this.$emit('update', selected_item);
      },    
    },
  }
</script>